<template>
  <div v-if="userStats" class="user-position-card bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl shadow-lg p-6 mb-6 text-white">
    <div class="flex items-center justify-between flex-wrap gap-4">
      <!-- User Info -->
      <div class="flex items-center gap-4">
        <div class="user-avatar">
          <i class="fas fa-user-circle text-5xl"></i>
        </div>
        <div>
          <h3 class="text-lg font-bold">{{ userStats.username }}</h3>
          <p class="text-sm opacity-90">Your Position</p>
        </div>
      </div>

      <!-- Stats Grid -->
      <div class="stats-grid grid grid-cols-2 md:grid-cols-3 gap-4">
        <!-- Global Rank -->
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fas fa-globe"></i>
          </div>
          <div class="stat-value">{{ formatRank(userStats.rank_global) }}</div>
          <div class="stat-label">Global Rank</div>
        </div>

        <!-- Total Score -->
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fas fa-star"></i>
          </div>
          <div class="stat-value">{{ userStats.total_score || 0 }}</div>
          <div class="stat-label">Total Score</div>
        </div>

        <!-- Quizzes Completed -->
        <div class="stat-item">
          <div class="stat-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="stat-value">{{ userStats.quizzes_completed || 0 }}</div>
          <div class="stat-label">Quizzes</div>
        </div>
      </div>
    </div>

    <!-- Country Ranks (if any) -->
    <div v-if="userStats.country_ranks && userStats.country_ranks.length > 0" class="country-ranks mt-6 pt-6 border-t border-white/20">
      <h4 class="text-sm font-semibold mb-3 opacity-90">Your Country Rankings</h4>
      <div class="flex flex-wrap gap-2">
        <div
          v-for="countryRank in userStats.country_ranks.slice(0, 5)"
          :key="countryRank.country_code"
          class="country-rank-badge bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2 flex items-center gap-2"
        >
          <span class="country-flag text-lg">{{ getCountryFlag(countryRank.country_code) }}</span>
          <span class="text-sm font-medium">Rank {{ countryRank.rank }}</span>
          <span class="text-xs opacity-75">{{ countryRank.total_score }} pts</span>
        </div>
        <div v-if="userStats.country_ranks.length > 5" class="country-rank-badge bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2">
          <span class="text-sm">+{{ userStats.country_ranks.length - 5 }} more</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserPositionCard',
  props: {
    userStats: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatRank(rank) {
      if (!rank) return 'N/A'
      if (rank === 1) return '🥇 1st'
      if (rank === 2) return '🥈 2nd'
      if (rank === 3) return '🥉 3rd'
      return `#${rank}`
    },
    getCountryFlag(countryCode) {
      if (!countryCode || countryCode.length !== 2) return '🌍'
      const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt())
      return String.fromCodePoint(...codePoints)
    }
  }
}
</script>

<style scoped>
.user-position-card {
  animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-avatar {
  animation: pulse 2s ease-in-out infinite;
}

.stat-item {
  text-align: center;
}

.stat-icon {
  font-size: 1.25rem;
  margin-bottom: 0.25rem;
  opacity: 0.8;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 0.25rem;
}

.stat-label {
  font-size: 0.75rem;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.country-rank-badge {
  transition: all 0.3s ease;
}

.country-rank-badge:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .stat-value {
    font-size: 1.25rem;
  }
}
</style>
